/**
 * @module store/promos/actions
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';


import { apiGetPromos, apiSetPromo, apiDeletePromo } from '@/api';
import * as types from '@/store/mutation-types';


/**
 * Action: Sign up of user
 *
 * @since Version 1.0.0
 */
const getPromos = async ({ commit, rootGetters }) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      const promos = await apiGetPromos(userSession.accessToken.jwtToken);
      commit(types.SET_PROMOS, promos);
    } else {
      throw new Error('Неавторизованный пользователь не может плучать информацию о точках.');
    }
  } catch (error) {
    console.log(error);
  }
};


/**
 * Action: Set promo
 *
 * @since Version 1.0.3
 */
const setPromo = async ({ dispatch, rootGetters }, promo) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiSetPromo(userSession.accessToken.jwtToken, promo);
      await dispatch('getPromos');
    } else {
      throw new Error('Неавторизованный пользователь не может менять информацию об акциях.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


/**
 * Action: Delete promo
 *
 * @since Version 1.0.3
 */
const deletePromo = async ({ dispatch, rootGetters }, id) => {
  try {
    if (rootGetters['user/isLoggin']) {
      const user = rootGetters['user/user'];
      const userSession = await Auth.userSession(user);

      await apiDeletePromo(userSession.accessToken.jwtToken, id);
      await dispatch('getPromos');
    } else {
      throw new Error('Неавторизованный пользователь не может удалять информацию об акциях.');
    }
  } catch (error) {
    console.log(error);
    return { error };
  }
  return 0;
};


export default {
  deletePromo,
  getPromos,
  setPromo,
};
